export const sendSignUpPageViewEvent = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'sign_up_page_view',
    })
  }
}

export const sendUserSignUpEvent = async (callback?: () => void) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    return new Promise<void>((resolve) => {
      const userSignUpEvent = {
        event: 'user_sign_up',
      }

      if (typeof callback === 'function') {
        const timerId = setTimeout(() => {
          callback?.()
          resolve()
        }, 2000)

        window.dataLayer.push({
          ...userSignUpEvent,
          eventCallback: () => {
            clearTimeout(timerId)
            callback?.()
            resolve()
          },
          eventTimeout: 2000,
        })
      } else {
        window.dataLayer.push(userSignUpEvent)
        resolve()
      }
    })
  }
}
